var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-block"},[_c('div',{staticClass:"chat-item chat-item--question"},[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"chat-item__inr"},[_c('div',{staticClass:"chat-item__txt"},[_c('div',{staticClass:"chat-item__txt__inr"},[_vm._v("\n            "+_vm._s(_vm.message)+"\n          ")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-897c9014","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/FormError.vue
// module id = null
// module chunks = 